import React, { useEffect, useRef, useState } from "react";

const AddressAutocomplete = ({
  onSelect,
  value = "",
  placeholder = "Enter address",
  showToast,
  className = "w-full",
}) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [isPlaceSelected, setIsPlaceSelected] = useState(false);

  useEffect(() => {
    if (!window.google || !inputRef.current) return;

    autocompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      { types: ["address"] }
    );

    autocompleteRef.current.setFields([
      "address_components",
      "formatted_address",
    ]);

    autocompleteRef.current.addListener("place_changed", () => {
      const place = autocompleteRef.current.getPlace();

      if (!place.address_components) return;

      const address = {
        full: place.formatted_address,
        street: "",
        route: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      };

      place.address_components.forEach((comp) => {
        const types = comp.types;
        if (types.includes("street_number"))
          address.street = comp.long_name + " " + address.street;
        if (types.includes("route")) address.route += comp.long_name;
        if (types.includes("locality")) address.city = comp.long_name;
        if (types.includes("administrative_area_level_1"))
          address.state = comp.long_name;
        if (types.includes("postal_code")) address.zip = comp.long_name;
        if (types.includes("country")) address.country = comp.long_name;
      });

      setIsPlaceSelected(true);
      onSelect(address);
    });
  }, []);

  // Keep the input updated when `value` prop changes (from API or state)
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = value || "";
    }
  }, [value]);

  // Handle blur to validate and clear
  const handleBlur = () => {
    const currentValue = inputRef.current.value.trim();

    // 🔹 Case 1: field cleared manually → update parent to empty
    if (currentValue === "") {
      onSelect(null);
      setIsPlaceSelected(false);
      return;
    }

    // 🔹 Case 2: invalid manual typing
    if (!isPlaceSelected) {
      showToast?.("Please select a valid address from suggestions.", "error");
      inputRef.current.value = "";
      onSelect(null);
    }

    setIsPlaceSelected(false);
  };

  return (
    <textarea
      ref={inputRef}
      type="text"
      placeholder={placeholder}
      onBlur={handleBlur}
      rows={3}
      className={`border p-2 rounded-md shadow-sm ${className}`}
    />
  );
};

export default AddressAutocomplete;
